export enum CollectionState {
  Requested = "requested",
  Booked = "booked",
  Collected = "collected",
  InTransit = "in_transit",
  Delivered = "delivered",
  Cancelled = "cancelled",
  Failed = "failed",
  DatePassed = "date_passed",
  Unconfirmed = "unconfirmed",
  Booking = "booking",
}
